import { Fragment, useState } from "react"
import { useLocation } from 'react-router-dom';
import { Btn } from "../../../../../AbstractElements";
import { CardHeader, Nav, NavItem, NavLink, Card, TabContent, Row, Col, TabPane } from "reactstrap";
import classnames from 'classnames';
import GeneralMedicalForm from "./GeneralMedicalForm";
import Dental from "./Dental";

const DiagnosisInfo = () => {

	const location = useLocation();

	const { data } = location.state || {};
  

  const [currentActiveTab, setCurrentActiveTab] = useState(''); 

  const toggle = tab => { 
		if (currentActiveTab !== tab) setCurrentActiveTab(tab); 
	} 


//   const handleSave = () => {
//     navigate('/patientinfo/treatment-plan')
//   }

  console.log(data)
  return(
    <Fragment>
      <Card>
        <CardHeader className='card-no-border'>
        <div className='mt-5'>
        <Nav tabs fill pills> 
				<NavItem> 
					<NavLink 
						className={classnames({ 
							active: 
								currentActiveTab === 'general'
						})} 
						onClick={() => { toggle('general'); }} 
					> 
						General Medical Record 
					</NavLink> 
				</NavItem> 
				<NavItem> 
					<NavLink 
						className={classnames({ 
							active: 
								currentActiveTab === 'dental'
						})} 
						onClick={() => { toggle('dental'); }} 
					> 
						Dental
					</NavLink> 
				</NavItem> 
			</Nav>
        </div>
        </CardHeader>
        <TabContent activeTab={currentActiveTab}>
        <TabPane tabId="general"> 
					<Row> 
						<Col sm="12"> 
							<GeneralMedicalForm patientData={data}/>
						</Col> 
					</Row> 
				</TabPane> 
				<TabPane tabId="dental"> 
					<Row> 
						<Col sm="12"> 
							<Dental data={data}/>
              {/* <div className="d-flex justify-content-end pr-5">
              <Btn attrBtn={{ color:'success', className: 'btn btn-xl', type: 'button', onClick: handleSave}}>save</Btn>
              </div> */}
						</Col> 
					</Row> 
				</TabPane> 

        </TabContent>
      </Card>
    </Fragment>
  )
}
export default DiagnosisInfo